/* Etsy vs Shopify fee calculator (sections/tc-calc-etsy.liquid). Recalculates as you type. */
(function () {
  var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  var money0 = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
  function num(v) { var n = parseFloat(String(v).replace(/[^0-9.\-]/g, '')); return isFinite(n) ? n : 0; }

  function init(root) {
    var qtyEl = root.querySelector('[data-tc="qty"]');
    var priceEl = root.querySelector('[data-tc="price"]');
    var rowsEl = root.querySelector('[data-tc="rows"]');
    var plans = Array.prototype.map.call(root.querySelectorAll('[data-tc="plans"] li'), function (li) {
      return { key: li.dataset.key, prefix: li.dataset.prefix || '', name: li.dataset.name, monthly: num(li.dataset.monthly), pct: num(li.dataset.pct) / 100, fixed: num(li.dataset.fixed) };
    });

    var asm = root.querySelector('[data-tc="assumptions"]');
    if (asm) {
      asm.innerHTML = plans.map(function (p) {
        return '<li><strong>' + p.name + ':</strong> ' + (p.monthly ? (p.prefix ? p.prefix + ' ' : '') + money.format(p.monthly) + '/month + ' : 'no monthly fee, ') +
          String(+(p.pct * 100).toFixed(2)) + '% + ' + money.format(p.fixed) + ' per order</li>';
      }).join('');
    }

    function render() {
      var qty = Math.max(0, Math.floor(num(qtyEl.value)));
      var price = Math.max(0, num(priceEl.value));
      var revenue = qty * price;
      var results = plans.map(function (p) {
        var perOrder = price * p.pct + p.fixed;
        var fees = perOrder * qty + p.monthly;
        return { p: p, perOrder: perOrder, fees: fees, keep: revenue - fees };
      });
      var best = results.reduce(function (a, b) { return b.keep > a.keep ? b : a; }, results[0]);
      var etsy = results.filter(function (r) { return r.p.key === 'etsy'; })[0];

      rowsEl.innerHTML = results.map(function (r) {
        var win = r === best && qty > 0 && price > 0;
        return '<div class="tc-calc__row' + (win ? ' is-best' : '') + '" role="row">' +
          '<span role="cell" class="tc-calc__name">' + r.p.name + (win ? ' <em class="tc-calc__tag">Best</em>' : '') + '</span>' +
          '<span role="cell" data-label="Monthly plan">' + (r.p.prefix ? '<small class="tc-calc__prefix">' + r.p.prefix + '</small> ' : '') + money.format(r.p.monthly) + '</span>' +
          '<span role="cell" data-label="Per-order fees">' + money.format(r.perOrder) + '</span>' +
          '<span role="cell" data-label="Total fees">' + money.format(r.fees) + '</span>' +
          '<span role="cell" data-label="You keep" class="tc-calc__keep">' + money.format(r.keep) + '</span>' +
          '</div>';
      }).join('');

      var nameEl = root.querySelector('[data-tc="best-name"]');
      var noteEl = root.querySelector('[data-tc="best-note"]');
      if (!(qty > 0 && price > 0)) {
        nameEl.textContent = '—';
        noteEl.textContent = 'Enter your orders and average order value.';
        return;
      }
      nameEl.textContent = best.p.name;
      if (etsy && best !== etsy) {
        noteEl.textContent = 'Keeps ' + money0.format(best.keep - etsy.keep) + ' more per month than Etsy (' + money0.format((best.keep - etsy.keep) * 12) + ' a year) on ' + money0.format(revenue) + ' in monthly sales.';
      } else if (etsy) {
        var next = results.filter(function (r) { return r !== etsy; }).reduce(function (a, b) { return b.keep > a.keep ? b : a; });
        noteEl.textContent = 'At this volume Etsy costs ' + money0.format(etsy.keep - next.keep) + ' less per month than ' + next.p.name + '. The gap closes as orders grow.';
      }
    }

    [qtyEl, priceEl].forEach(function (el) { el.addEventListener('input', render); });
    render();
  }

  function boot() { document.querySelectorAll('[data-tc-calc-etsy]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
